export const ID = Symbol.for('@xgraph/graphId');
export const TYPE = Symbol.for('@xgraph/graphType');
